;(function($, undefined){
    var rnn, actions;

    function add(key, options) {
        var settings, url, callback;

        settings = options || {};
        url = settings.url || '';
        callback = settings.callback || function () {};
        actions[key] = {url: url, callback: callback};
    }

    function del(key) {
        if (actions[key]) {
            delete actions[key];
        }
    }

    function record(key) {
        if (actions[key]) {
            $.getJSON(actions[key].url, actions[key].callback);
            del(key);
        }
    }

    function keyFromURL(action, url) {
        if (url.indexOf('://') > -1) {
            return action + ":/" + url.split("#")[0].split("/").slice(3).join("/");
        } else {
            return action + ":" + url;
        }
    }

    function initActions() {
        $('*[data-activity-action]').each(function () {
            var data = $(this).data('activityAction');
            add(data.key, data.options);
        });
    }

    function hashCheck() {
        if ($('.profile-nav-tabs').length > 0) {
            var hash = location.hash.match(/^#?(.*)$/)[1]; // bulletproof way to grab the hash

            if (hash) {
                var $btn = $('.' + hash + 'Btn');
                if ($btn.length > 0) {
                    $btn.click();
                }
            }
        }
    }

    function initActivityStreams() {
        $('.activityStream').each(function () {
            var $activityStream = $(this);
            var $activityStreamMore = $activityStream.find('.activityStreamMore');
            var $activityStreamMoreBtn = $activityStreamMore.find('.btn');
            var hasNext = $activityStream.data('activityStream').hasNext;

            hasNext || $activityStreamMore.hide();

            $activityStreamMoreBtn.click(function (event) {
                event.preventDefault();
                $.ajax({
                    url: window.location.pathname,
                    data: {
                        'last_pk': $activityStream.find(".action").last().data('id')
                    },
                    beforeSend: function () {
                        $activityStreamMoreBtn.button('loading');
                    },
                    success: function (data) {
                        $activityStream.find(".actions").append(data.user_actions);
                        $activityStreamMore.toggle(data.has_next);
                    },
                    complete: function () {
                        $activityStreamMoreBtn.button('reset');
                    }
                });
            });
        });
    }

    // Initialise Activity
    function initActivity() {
        initActions();
        initActivityStreams();
        hashCheck();
    }

    rnn = window.rnn;

    actions = {};

    rnn.modules.register('activity', {
        actions: actions,
        add: add,
        del: del,
        record: record,
        keyFromURL: keyFromURL,
        init: initActivity
    });

    // Legacy support
    window.Activity = {
        add: add,
        record: record
    };

})(jQuery);
